import React, { useEffect, useState } from 'react';
import { Warehouse } from 'lucide-react';
import { vehicleStore } from '../services/vehicleStore';
import { authAPI, myVehiclesAPI } from '../services/api';
import { useT } from '../services/i18n';

// Logged-in customers switch the active vehicle from their garage (cart summary, product page)
const GarageSwitcher = ({ vehicle, testId = 'garage', className = 'mb-4 -mt-2' }) => {
  const { t } = useT();
  const [garage, setGarage] = useState([]);
  useEffect(() => {
    if (!authAPI.isAuthenticated()) return;
    myVehiclesAPI.list().then(setGarage).catch(() => {});
  }, []);
  if (!garage.length || (garage.length === 1 && vehicleStore.same(garage[0], vehicle))) return null;
  const current = garage.findIndex(v => vehicleStore.same(v, vehicle));
  const onChange = (e) => {
    const v = garage[Number(e.target.value)];
    if (v) vehicleStore.set({ brand: v.brand, model: v.model, year: v.year, engine: v.engine || null, plate: v.plate || null });
  };
  return (
    <div className={className} data-testid={`${testId}-garage`}>
      <label className="flex items-center gap-1.5 text-[11px] font-medium text-gray-600 mb-1" htmlFor={`${testId}-garage-select`}><Warehouse size={12} /> {t('cart.garageSwitch')}</label>
      <select id={`${testId}-garage-select`} value={current >= 0 ? current : ''} onChange={onChange} data-testid={`${testId}-garage-select`}
        className="w-full text-sm border border-gray-200 rounded-md py-1.5 px-2 bg-white focus:outline-none focus:ring-2 focus:ring-orange-300">
        {current < 0 && <option value="">{t('cart.garagePick')}</option>}
        {garage.map((v, i) => <option key={v.id} value={i}>{v.brand} {v.model} ({v.year}){v.engine?.name ? ` · ${v.engine.name}` : ''}{v.plate ? ` · ${v.plate}` : ''}</option>)}
      </select>
      <p className="text-[11px] text-gray-400 mt-1">{t('cart.garageHint')}</p>
    </div>
  );
};

export default GarageSwitcher;
